import { render, staticRenderFns } from "./ClientsSideviewCreditTab.vue?vue&type=template&id=05dd6b8a&scoped=true&"
import script from "./ClientsSideviewCreditTab.vue?vue&type=script&lang=ts&"
export * from "./ClientsSideviewCreditTab.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsSideviewCreditTab.vue?vue&type=style&index=0&id=05dd6b8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd6b8a",
  null
  
)

export default component.exports